import * as React from 'react';
import compose from 'recompose/compose';
import { withCurrentUser } from 'src/components/withCurrentUser';
import { history } from 'src/helpers/history';
import queryString from 'query-string';
import Routes from 'src/routes';

class RedirectHandler extends React.Component {
  componentDidUpdate(prev) {
    const curr = this.props;
    const params = queryString.parse(history.location.search);
    const doneFetching =
      prev.isloadingcurrentuser && !curr.isloadingcurrentuser;

    if (doneFetching) {
      // Redirect ?t=asdfxyz to the thread view only for anonymous users who wouldn't see it
      // in their inbox view (since they don't have an inbox view)
      if (!curr.currentUser && params.t) {
        history.replace(`/thread/${params.t}`);
      }
    }
  }

  render() {
    return <Routes maintenanceMode={this.props.maintenanceMode} />;
  }
}

export default compose(withCurrentUser)(RedirectHandler);
